import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_ABOUT_PROFILES, getProfileInitials } from '../lib/aboutProfiles';

function ProfileAvatar({ profile }) {
  const [imageFailed, setImageFailed] = useState(false);

  if (profile.image_url && !imageFailed) {
    return (
      <img
        src={profile.image_url}
        alt=""
        className="about-profile-card__avatar about-profile-card__avatar--image"
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <div className="about-profile-card__avatar" aria-hidden="true">
      {getProfileInitials(profile.name)}
    </div>
  );
}

export default function AboutPage() {
  const [profiles, setProfiles] = useState(DEFAULT_ABOUT_PROFILES);

  useEffect(() => {
    let active = true;
    fetch('/api/about')
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error('About Us could not be loaded.'))))
      .then((data) => {
        if (active && Array.isArray(data) && data.length) setProfiles(data);
      })
      .catch(() => {
        // The seeded profiles keep the page useful if the optional request is unavailable.
      });
    return () => { active = false; };
  }, []);

  return (
    <div className="container about-page py-5">
      <section className="about-page__people" aria-labelledby="about-people-title">
        <div className="about-page__section-heading">
          <div>
            <h1 id="about-people-title" className="brand-font">Meet The Team</h1>
          </div>
          <span className="about-page__count">{profiles.length} profiles</span>
        </div>

        <div className="about-profile-grid">
          {profiles.filter((profile) => profile.enabled !== false).map((profile) => (
            <article className="about-profile-card" key={profile.slug}>
              <div className="about-profile-card__topline">
                <ProfileAvatar profile={profile} />
                <div className="about-profile-card__heading">
                  <p className="about-profile-card__role">{profile.role}</p>
                  <h3>{profile.name}</h3>
                  {(profile.age || profile.gender) && (
                    <p className="about-profile-card__meta">
                      {[profile.gender, profile.age ? `${profile.age} years` : ''].filter(Boolean).join(' · ')}
                    </p>
                  )}
                </div>
              </div>
              <p className="about-profile-card__bio">{profile.bio}</p>
              {profile.detail && <p className="about-profile-card__detail">{profile.detail}</p>}
              {profile.profile_url && (
                <a href={profile.profile_url} target="_blank" rel="noopener noreferrer" className="about-profile-card__link">
                  View profile <span aria-hidden="true">↗</span>
                </a>
              )}
            </article>
          ))}
        </div>
      </section>

      <section className="about-page__footer-card">
        <div>
          <p className="about-page__section-label">Stay close to the work</p>
          <h2>Find something that feels like you.</h2>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <Link to="/shop" className="btn btn-primary-custom">Browse the shop</Link>
          <Link to="/custom-orders?new=1" className="btn btn-outline-custom">Request something custom</Link>
        </div>
      </section>
    </div>
  );
}
